var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Page Not Found")]),_c('router-link',{attrs:{"to":{ name: 'login' },"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var navigate = ref.navigate;
return [_c('a-button',{attrs:{"type":"primary"},domProps:{"textContent":_vm._s(_vm.$t('btn_back_login'))},on:{"click":navigate}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }